import { apiClient } from './client'
import type { AppEventRequest, MiniAppRuntimePayload } from './miniappTypes'

class MiniAppsAPI {
  async createInstance(
    deploymentId: string,
    miniAppId: string,
    options?: {
      miniAppVersion?: string
      seedState?: Record<string, unknown>
      seedData?: Record<string, unknown>
    },
  ): Promise<MiniAppRuntimePayload> {
    return apiClient.post(
      `/organization/miniapp/${deploymentId}/${miniAppId}/instances`,
      {
        miniapp_version: options?.miniAppVersion,
        seed_state: options?.seedState,
        seed_data: options?.seedData,
      },
    )
  }

  async getInstance(appInstanceId: string): Promise<MiniAppRuntimePayload> {
    return apiClient.get(`/organization/miniapp/instances/${appInstanceId}`)
  }

  async sendEvent(
    appInstanceId: string,
    eventId: string,
    payload: AppEventRequest,
  ): Promise<MiniAppRuntimePayload> {
    return apiClient.post(
      `/organization/miniapp/instances/${appInstanceId}/events/${eventId}`,
      payload,
    )
  }
}

export const miniappsAPI = new MiniAppsAPI()
